import { getPresPreSignedUrl } from "../../SalesService";

const isAbsoluteHttpUrl = (value) =>
	/^https?:\/\//i.test(String(value || "").trim());

/** Resolve storage key → temporary preview URL. Passes through absolute URLs. */
export const resolveInvoicePresignedUrl = async (invoiceUrl) => {
	const key = String(invoiceUrl || "").trim();
	if (!key) return "";
	if (isAbsoluteHttpUrl(key)) return key;

	try {
		const response = await getPresPreSignedUrl({ key });
		return response?.data?.data?.presignedURL || "";
	} catch (error) {
		console.error("Error resolving invoice presigned URL:", error);
		throw error;
	}
};
